import {prefix} from '../config'

async function fetchData(url, data) {
  // const prefix = process.env.NODE_ENV === 'development' ? `https://www.sydev.info` : ``
  let _url
  // const login = 'shenyun'
  // const password = 'golive!'
  // const auth = btoa('shenyun:golive!')
  const h = new Headers()
  // h.append('Accept', 'application/json')
  // const encoded = window.btoa('shenyun:golive!')
  // const auth = `Basic ${encoded}`
  // h.append('Authorization', auth)

  if (data) {
    const params =
      typeof data === 'string'
        ? data
        : Object.keys(data)
            .map(k => {
              return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
            })
            .join('&')
    _url = `${prefix}${url}?${params}`
  } else {
    _url = `${prefix}${url}`
  }

  const response = await fetch(
    new Request(_url, {
      method: 'GET',
      headers: h,
      // headers: new Headers({
      //   'Authorization': `Basic ${btoa(`${login}:${password}`)}`,
      // }),
    })
  )

  // the server responds with confirmation and the image size
  const result = await response.json()
  return result
}

export async function fetchContent(url, data) {
  let _url
  if (data) {
    const params =
      typeof data === 'string'
        ? data
        : Object.keys(data)
            .map(k => {
              return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
            })
            .join('&')
    _url = `${prefix}${url}?${params}`
  } else {
    _url = `${prefix}${url}`
  }

  const h = new Headers()
  h.append('Accept', 'text/html')
  // const encoded = window.btoa('shenyun:golive!')
  // const auth = `Basic ${encoded}`
  // h.append('Authorization', auth)
  // console.debug(auth)
  const response = await fetch(
    new Request(_url, {
      method: 'GET',
      headers: h,
    })
  )

  const result = await response.text()
  return result
}

export async function fetchDataCross(url, data) {
  const prefixCross = process.env.NODE_ENV === 'development' ? `https://www.sydev.org` : `https://www.sydev.org`
  let _url
  const headers = new Headers()
  if (data) {
    const params =
      typeof data === 'string'
        ? data
        : Object.keys(data)
            .map(k => {
              return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
            })
            .join('&')
    _url = `${prefixCross}${url}?${params}`
  } else {
    _url = `${prefixCross}${url}`
  }

  const response = await fetch(
    new Request(_url, {
      method: 'GET',
      headers,
    })
  )

  const result = await response.json()
  return result
}

export default fetchData
